import { applyMiddleware, combineReducers, createStore } from 'redux';
import ReduxThunk from 'redux-thunk';

import login from '../reducers/login';
import tokens from '../reducers/tokens';

const reducer = combineReducers({ login, tokens });

const store = createStore(reducer, applyMiddleware(ReduxThunk));

export default store;
